/* ============================================
   WOODENXA SHOPIFY THEME v3.0 — woodenxa.js
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ═══════════════════════════════
     TOAST NOTIFICATION
  ═══════════════════════════════ */
  window.showToast = function(msg) {
    let t = document.getElementById('toast-msg');
    if (!t) {
      t = document.createElement('div');
      t.id = 'toast-msg';
      t.className = 'toast-message';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 3000);
  };

  /* ═══════════════════════════════
     CART DRAWER OPEN/CLOSE
  ═══════════════════════════════ */
  const cartOverlay = document.getElementById('cart-overlay');
  const cartPanel   = document.getElementById('cart-panel');

  window.openCart  = function() { cartOverlay?.classList.add('open'); cartPanel?.classList.add('open'); refreshCartDrawer(); };
  window.closeCart = function() { cartOverlay?.classList.remove('open'); cartPanel?.classList.remove('open'); };

  document.querySelectorAll('[data-cart-trigger]').forEach(el => el.addEventListener('click', window.openCart));
  document.getElementById('cart-close')?.addEventListener('click', window.closeCart);
  cartOverlay?.addEventListener('click', window.closeCart);

  /* ═══════════════════════════════
     REFRESH CART DRAWER (AJAX)
  ═══════════════════════════════ */
  window.refreshCartDrawer = function() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

        const body   = document.getElementById('cart-panel-body');
        const footer = document.getElementById('cart-panel-footer');
        if (!body) return;

        if (cart.items.length === 0) {
          body.innerHTML = '<div class="cart-empty-state">Your cart is empty.<br><a href="/collections/all" style="color:var(--m2);text-decoration:underline;margin-top:12px;display:inline-block;">Browse our collection →</a></div>';
          if (footer) footer.style.display = 'none';
          return;
        }

        if (footer) footer.style.display = 'block';

        body.innerHTML = cart.items.map(function(item) {
          const linePrice = (item.line_price / 100).toLocaleString();
          const safeName  = (item.product_title || '').substring(0, 36).replace(/</g, '&lt;');
          const imgTag    = item.image
            ? '<img src="' + item.image + '" alt="' + safeName + '" style="width:100%;height:100%;object-fit:cover;">'
            : '📦';
          const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div style="font-size:11.5px;color:var(--m2);">' + item.variant_title + '</div>'
            : '';
          return '<div class="cart-item">' +
            '<div class="cart-item-img">' + imgTag + '</div>' +
            '<div style="flex:1;">' +
              '<div class="cart-item-name">' + safeName + '</div>' +
              variantLine +
              '<div class="cart-item-price">Rs.' + linePrice + '</div>' +
              '<div class="cart-item-qty">' +
                '<div class="qty-btn" onclick="window.changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</div>' +
                '<span class="qty-val">' + item.quantity + '</span>' +
                '<div class="qty-btn" onclick="window.changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</div>' +
                '<span onclick="window.changeQty(\'' + item.key + '\',0)" style="margin-left:10px;font-size:20px;cursor:pointer;color:#bbb;line-height:1;">×</span>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');

        const subtotal = cart.total_price / 100;
        const subEl = document.getElementById('cart-subtotal-value');
        if (subEl) subEl.textContent = 'Rs.' + subtotal.toLocaleString();

        const threshold = 2000;
        const freeEl = footer ? footer.querySelector('.cart-free-shipping') : null;
        if (freeEl) {
          if (subtotal >= threshold) {
            freeEl.textContent = '🚚 Free delivery included!';
            freeEl.style.background = 'var(--grn2)';
            freeEl.style.color = 'var(--grn)';
          } else {
            freeEl.textContent = 'Add Rs.' + Math.round(threshold - subtotal).toLocaleString() + ' more for free delivery!';
            freeEl.style.background = '#FFF8E6';
            freeEl.style.color = '#8B6010';
          }
        }
      })
      .catch(function(err) { console.warn('Cart refresh error:', err); });
  };

  /* ═══════════════════════════════
     CHANGE QTY IN CART
  ═══════════════════════════════ */
  window.changeQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
    .then(function(r) { return r.json(); })
    .then(function() { window.refreshCartDrawer(); })
    .catch(function(err) { console.warn('changeQty error:', err); });
  };

  /* ═══════════════════════════════
     ADD TO CART (universal handler)
  ═══════════════════════════════ */
  function doAddToCart(variantId, productName, qty, btn) {
    if (!variantId) { window.showToast('Please select a variant.'); return; }
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        window.showToast('Error: ' + (data.description || 'Could not add to cart.'));
      } else {
        window.showToast('✓ ' + (productName || 'Product').substring(0, 28) + ' added!');
        window.refreshCartDrawer();
        window.openCart();
      }
    })
    .catch(function() { window.showToast('Added to cart!'); })
    .finally(function() {
      if (btn) {
        btn.textContent = btn.classList.contains('pca-atc') ? 'Add to Cart' : (btn.classList.contains('satc-btn') ? 'Add to Cart' : 'Add +');
        btn.disabled = false;
      }
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      const qty = parseInt(document.getElementById('product-qty')?.value || 1);
      doAddToCart(this.dataset.variantId, this.dataset.productName, qty, this);
    });
  });

  window.quickAdd = function(variantId, name) {
    doAddToCart(variantId, name, 1, null);
  };

  /* ═══════════════════════════════
     WISHLIST BUTTONS
  ═══════════════════════════════ */
  document.querySelectorAll('[data-wishlist]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      this.innerHTML = '♥';
      this.style.color = '#B83232';
      window.showToast('Added to wishlist ♡');
    });
  });

  /* ═══════════════════════════════
     NEWSLETTER
  ═══════════════════════════════ */
  const nlForm = document.getElementById('newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function(e) {
      const emailInput = this.querySelector('input[type="email"]');
      if (!emailInput?.value?.includes('@')) {
        e.preventDefault();
        window.showToast('Please enter a valid email address.');
      }
    });
  }

  /* ═══════════════════════════════
     CART CONTINUE SHOPPING
  ═══════════════════════════════ */
  document.getElementById('cart-close-bottom')?.addEventListener('click', window.closeCart);

  /* ═══════════════════════════════
     LIVE PURCHASE NOTIFICATIONS
     Random delay 7-13 sec (natural feel)
  ═══════════════════════════════ */
  var buyers = [
    { name: 'Ahmed from Lahore',      prod: 'just purchased Watch Box',          emoji: '⌚', time: '2 minutes ago'  },
    { name: 'Sana from Karachi',      prod: 'just purchased Jewelry Box',         emoji: '💍', time: '5 minutes ago'  },
    { name: 'Fatima from Islamabad',  prod: 'just ordered Ayatul Kursi Art',      emoji: '🕌', time: '1 minute ago'   },
    { name: 'Zaid from Peshawar',     prod: 'just purchased Tea Mates Set',       emoji: '☕', time: '3 minutes ago'  },
    { name: 'Maryam from Multan',     prod: 'just purchased Mobile Stand',        emoji: '📱', time: '7 minutes ago'  },
    { name: 'Hassan from Lahore',     prod: 'just ordered Coffee Table',          emoji: '🪑', time: '4 minutes ago'  },
    { name: 'Ayesha from Faisalabad', prod: 'just purchased Tissue Box',          emoji: '🧻', time: '6 minutes ago'  },
    { name: 'Omar from Rawalpindi',   prod: 'just purchased 3-Layer Jewelry Box', emoji: '💎', time: '8 minutes ago'  },
    { name: 'Bilal from Quetta',      prod: 'just ordered Cutting Board Set',     emoji: '🔪', time: '11 minutes ago' },
    { name: 'Nadia from Faisalabad',  prod: 'just purchased Wooden Tray',         emoji: '🍽️', time: '9 minutes ago'  },
  ];
  var buyerIdx = 0;

  function showBuyerNotif() {
    var notif = document.getElementById('live-notif');
    if (!notif) return;
    var b = buyers[buyerIdx % buyers.length]; buyerIdx++;
    var nameEl  = notif.querySelector('[data-ln-name]');
    var prodEl  = notif.querySelector('[data-ln-prod]');
    var emojiEl = notif.querySelector('[data-ln-emoji]');
    var timeEl  = notif.querySelector('[data-ln-time]');
    if (nameEl)  nameEl.textContent  = b.name;
    if (prodEl)  prodEl.textContent  = b.prod;
    if (emojiEl) emojiEl.textContent = b.emoji;
    if (timeEl)  timeEl.textContent  = b.time;
    notif.classList.add('show');
    setTimeout(function() { notif.classList.remove('show'); }, 4500);

    // Random delay between 7-13 seconds (natural, not fake looking)
    setTimeout(showBuyerNotif, Math.floor(Math.random() * 6000) + 7000);
  }
  setTimeout(showBuyerNotif, Math.floor(Math.random() * 4000) + 5000);

  /* ═══════════════════════════════
     INITIAL CART COUNT LOAD
  ═══════════════════════════════ */
  window.refreshCartDrawer();

});

/* ═══════════════════════════════════════════════
   selectPM is defined in product-main.liquid
   directly — no override needed here
═══════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════
   ADVANCE PAYMENT MODAL
   Meezan Bank + Till ID + WhatsApp
═══════════════════════════════════════════════ */
window.showAdvancePaymentModal = function(discountPct) {
  discountPct = discountPct || 10;
  var discCode = 'ADVANCE10';

  var existing = document.getElementById('adv-pay-modal');
  if (existing) existing.remove();

  var modal = document.createElement('div');
  modal.id = 'adv-pay-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.78);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;';

  modal.innerHTML = '<div style="background:#FFFCF8;max-width:420px;width:100%;border-top:4px solid #C9A84C;max-height:90vh;overflow-y:auto;">' +

    '<div style="background:#120900;padding:16px 20px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:1;">' +
      '<div style="font-family:Georgia,serif;font-size:17px;color:#fff;">⭐ Advance Payment</div>' +
      '<button onclick="document.getElementById(\'adv-pay-modal\').remove()" style="background:rgba(255,255,255,0.1);border:none;color:rgba(255,255,255,0.7);font-size:20px;cursor:pointer;width:32px;height:32px;display:flex;align-items:center;justify-content:center;border-radius:4px;">✕</button>' +
    '</div>' +

    '<div style="padding:18px;">' +

      '<div style="background:#E6F4ED;border:1px solid rgba(26,112,72,0.25);padding:12px 14px;margin-bottom:16px;display:flex;gap:10px;align-items:flex-start;">' +
        '<span style="font-size:22px;flex-shrink:0;">✅</span>' +
        '<div>' +
          '<div style="font-size:14px;font-weight:700;color:#120900;margin-bottom:2px;">Item cart mein add ho gaya!</div>' +
          '<div style="font-size:12.5px;color:#1A7048;">Payment karein — ' + discountPct + '% discount automatically apply hogi</div>' +
        '</div>' +
      '</div>' +

      '<a href="/checkout?discount=' + discCode + '" style="display:flex;align-items:center;justify-content:center;gap:8px;background:#120900;color:#fff;padding:15px;font-size:15px;font-weight:700;text-decoration:none;margin-bottom:16px;border:2px solid #C9A84C;">' +
        '✅ Checkout with ' + discountPct + '% Discount →' +
      '</a>' +

      '<div style="text-align:center;font-size:12px;color:#9A6020;margin-bottom:16px;font-weight:600;">— YA — Pehle payment karein phir WhatsApp screenshot bhejein —</div>' +

      '<div style="font-size:11px;font-weight:700;color:#9A6020;letter-spacing:1px;text-transform:uppercase;margin-bottom:10px;">Payment Options:</div>' +

      '<div style="border:1.5px solid #C9A84C;padding:14px;background:#FFFDF4;margin-bottom:10px;">' +
        '<div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:12px;">' +
          '<div style="width:44px;height:44px;background:#1A4B8C;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:22px;">🏦</div>' +
          '<div style="flex:1;">' +
            '<div style="font-size:14px;font-weight:700;color:#120900;">Meezan Bank Transfer</div>' +
            '<div style="font-size:11.5px;color:#9A6020;margin-top:2px;">Direct bank transfer ya any ATM/app se</div>' +
          '</div>' +
        '</div>' +
        '<div style="background:#fff;border:1px solid rgba(0,0,0,0.08);padding:12px;margin-bottom:8px;">' +
          '<table style="width:100%;font-size:13px;border-collapse:collapse;">' +
            '<tr><td style="color:#9A6020;padding:4px 0;width:40%;">Title Name</td><td style="font-weight:700;color:#120900;padding:4px 0;">WOODENXA</td></tr>' +
            '<tr><td style="color:#9A6020;padding:4px 0;">Bank</td><td style="font-weight:700;color:#120900;padding:4px 0;">Meezan Bank</td></tr>' +
            '<tr><td style="color:#9A6020;padding:4px 0;vertical-align:middle;">Account #</td>' +
            '<td style="padding:4px 0;">' +
              '<span style="font-weight:700;color:#120900;font-size:14px;">98530113821426</span>' +
              '<button onclick="window.copyPayNum(\'98530113821426\',this)" style="background:#120900;color:#fff;border:none;padding:3px 10px;font-size:11px;font-weight:700;cursor:pointer;margin-left:8px;border-radius:2px;">Copy</button>' +
            '</td></tr>' +
          '</table>' +
        '</div>' +
        '<div style="font-size:12px;color:#5C3010;line-height:1.65;background:#FFF8E6;padding:10px;border-left:3px solid #C9A84C;">' +
          '<b>Kaise karein?</b><br>' +
          '1. Apni banking app kholo (HBL, MCB, UBL, Meezan, etc.)<br>' +
          '2. Fund Transfer → Other Bank → Meezan Bank<br>' +
          '3. Account number: <b>98530113821426</b><br>' +
          '4. Amount daalo → Transfer karein' +
        '</div>' +
      '</div>' +

      '<div style="border:1.5px solid rgba(0,0,0,0.1);padding:14px;background:#fff;margin-bottom:16px;">' +
        '<div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:12px;">' +
          '<div style="width:44px;height:44px;background:#2E7D32;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:22px;">🏪</div>' +
          '<div style="flex:1;">' +
            '<div style="font-size:14px;font-weight:700;color:#120900;">Till ID — Kisi bhi Dukaan se</div>' +
            '<div style="font-size:11.5px;color:#9A6020;margin-top:2px;">Nearest retailer / kiryana store se cash payment</div>' +
          '</div>' +
        '</div>' +
        '<div style="background:#F0F7F0;border:1px solid rgba(46,125,50,0.2);padding:12px;margin-bottom:10px;text-align:center;">' +
          '<div style="font-size:12px;color:#2E7D32;font-weight:600;margin-bottom:4px;">Woodenxa Till ID</div>' +
          '<div style="font-size:28px;font-weight:700;color:#120900;letter-spacing:2px;">922533087</div>' +
          '<button onclick="window.copyPayNum(\'922533087\',this)" style="background:#2E7D32;color:#fff;border:none;padding:7px 20px;font-size:12px;font-weight:700;cursor:pointer;margin-top:8px;border-radius:2px;">Copy Till ID</button>' +
        '</div>' +
        '<div style="font-size:12px;color:#5C3010;line-height:1.75;background:#F5F5F5;padding:12px;border-left:3px solid #2E7D32;">' +
          '<b style="font-size:13px;color:#120900;">Till ID se payment kaise karein:</b><br><br>' +
          '<b>📱 Mobile App se (JazzCash / Easypaisa / Nayapay):</b><br>' +
          '1. App kholo → <b>Send Money</b> ya <b>Pay to Merchant</b><br>' +
          '2. <b>"Till ID"</b> option select karo<br>' +
          '3. Till ID enter karo: <b>922533087</b><br>' +
          '4. Amount enter karo → Confirm<br><br>' +
          '<b>🏪 Dukaan / Retailer se:</b><br>' +
          '1. Nearest JazzCash / Easypaisa retailer pe jaao<br>' +
          '2. Unhe bolo: <b>"Till ID pe payment karni hai"</b><br>' +
          '3. Till ID batao: <b>922533087</b><br>' +
          '4. Cash dein → Receipt lo' +
        '</div>' +
      '</div>' +

      '<div style="background:#FFF8E6;border:1.5px solid #C9A84C;padding:14px;margin-bottom:14px;">' +
        '<div style="font-size:13px;font-weight:700;color:#120900;margin-bottom:6px;">📸 Payment ke baad kya karein?</div>' +
        '<div style="font-size:13px;color:#5C3010;line-height:1.7;margin-bottom:12px;">' +
          'Payment screenshot WhatsApp pe bhejein:<br>' +
          '<span style="font-size:17px;font-weight:700;color:#120900;letter-spacing:.5px;">+92 315-8627222</span>' +
        '</div>' +
        '<a href="https://wa.me/923158627222?text=Assalam%20o%20Alaikum%20Woodenxa!%20Maine%20advance%20payment%20kar%20di%20hai.%20Screenshot%20attach%20hai.%20Order%20confirm%20kar%20dein.%20Shukriya!" target="_blank" style="display:flex;align-items:center;justify-content:center;gap:8px;background:#25D366;color:#fff;padding:13px;font-size:14px;font-weight:700;text-decoration:none;">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
          'Screenshot WhatsApp pe bhejein →' +
        '</a>' +
      '</div>' +

      '<div style="font-size:12px;color:#aaa;text-align:center;line-height:1.65;">' +
        'Payment verify hone ke baad aapka order confirm hoga ✓<br>' +
        'WhatsApp pe order number bhej diya jayega' +
      '</div>' +

    '</div>' +
  '</div>';

  document.body.appendChild(modal);
  modal.addEventListener('click', function(e) {
    if (e.target === modal) modal.remove();
  });
};

window.copyPayNum = function(text, btn) {
  navigator.clipboard.writeText(text).then(function() {
    var orig = btn.textContent;
    btn.textContent = '✓ Copied';
    btn.style.background = '#1A7048';
    setTimeout(function() {
      btn.textContent = orig;
      btn.style.background = orig === 'Copy Till ID' ? '#2E7D32' : '#120900';
    }, 2000);
  });
};